import $ from 'jquery';

//375px未満のデバイスはビューポートの幅を375pxにする
if(document.documentElement.clientWidth < 375){
	$('meta[name="viewport"]').attr('content', 'width=375, user-scalable=yes');
}

//ヘッダーメニューの開閉
$("#headerMenuBtn").on("click", function(){
	const ariaExpanded = $(this).attr("aria-expanded");
	const ariaControls = $(this).attr("aria-controls");
	const ariaControlsObj = $("#" + ariaControls);
	if(ariaExpanded === "true"){
		//メニューを閉じたとき
		$(this).attr("aria-expanded","false");
		ariaControlsObj.attr("aria-hidden","true").stop().fadeOut(300);
	}else{
		//メニューを開いた時
		$(this).attr("aria-expanded","true");
		ariaControlsObj.attr("aria-hidden","false").stop().fadeIn(300);
	}
});

//メニューのリンククリックでメニューを閉じる
$("#header a").on("click", function(){
	$("#headerMenuBtn").attr("aria-expanded","false");
});

//「戻る」で再度ページを表示した場合にメニューを閉じる
$(window).on("pageshow",function(e){
	if(e.originalEvent.persisted){
		$("#headerMenuBtn").attr("aria-expanded","false");
	}
});


//ダイアログ
$(".dialogBtn").on("click", function(){
	document.querySelector($(this).attr("data-target")).showModal();
});

$(".dialog").on("click", function(event){
	if(event.target.closest('form') === null) {
		$(this).get(0).close();
	}
});


//ログアウト
$(".logoutBtn").on("click", function(){
	if (window.confirm("ログアウトしますか？")) {
		return true;
	}else{
		return false;
	}
});